module.exports = __webpack_public_path__ + "static/img5-5085e372f3bb79bb644356730bf42217.jpg";